export const UMB_TREE_PICKER_MODAL_ALIAS = 'Umb.Modal.TreePicker';
